module.exports = __webpack_public_path__ + "img/infoImg7.b805790c.png";